import { Directive, HostBinding, Input } from '@angular/core';
import { ButtonDirective } from '../button/button.directive';

export type AppFlatButtonColor = 'default' | 'primary' | 'secondary';

@Directive({
  selector: '[appFlatButton]'
})
export class FlatButtonDirective extends ButtonDirective {
  // flat button appearance
  @Input() @HostBinding('attr.ts-color') color: AppFlatButtonColor = 'default';
  // flat button class
  @HostBinding('class.ts-flat-button') flatButtonClass = true;

  constructor() {
    super();
  }
}
